import FanReportCreatorModalComponent from "./FanReportCreatorModalComponent";

export default FanReportCreatorModalComponent;
